export default __webpack_public_path__ + "static/media/output-onlinegiftools.dad52f04.gif";